import { connect } from 'react-redux';
import {
  onShowEditModal as onEdit,
  chooseAddress,
  showDeleteModal as showModal,
  showSaveAsContactAddressModal,
  addressApiError,
} from 'redux/modules/address/actions';
import { optionsLoadingAddressId } from 'redux/modules/address/selectors';
import { getAddressInError } from 'redux/modules/address/selectors/get-address-selectors';
import AddressTile from './AddressTile';

const mapStateToProps = (state, props) => {
  const {
    address: { id },
    address,
    showContactNumber = true,
    isEditable = true,
  } = props;
  const optionsAddressId = optionsLoadingAddressId(state);
  const addressInError = getAddressInError(state);
  const inError = addressInError && addressInError.id === id;

  return {
    showContactNumber,
    address,
    isEditable,
    selected: false,
    optionsLoading: optionsAddressId === id,
    inError,
  };
};

const mapDispatchToProps = dispatch => ({
  onEdit: async address =>
    dispatch(onEdit(address)).catch(error => {
      if (error && error.status) {
        dispatch(addressApiError(address));
        return { hasError: true };
      }
      throw error;
    }),
  showModal: async address =>
    dispatch(showModal(address)).catch(error => {
      if (error && error.status) {
        dispatch(addressApiError(address));
        return { hasError: true };
      }
      throw error;
    }),
  showSaveAsContactAddressModal: async address =>
    dispatch(showSaveAsContactAddressModal(address)).catch(error => {
      if (error && error.status) {
        dispatch(addressApiError(address));
        return { hasError: true };
      }
      throw error;
    }),
  chooseAddress: async address => dispatch(chooseAddress(address)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressTile);
